import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, inr } from "@/lib/api";
import Navbar from "@/components/Navbar";

const pillCls = (s) => s === "confirmed" ? "status-paid" : s === "rejected" ? "status-failed" : "status-unpaid";

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [invoices, setInvoices] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Promise.all([api.get("/orders"), api.get("/invoices")]).then(([o, i]) => {
      setOrders(o.data);
      const map = {}; i.data.forEach((x) => { map[x.id] = x; });
      setInvoices(map);
      setLoading(false);
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-10">
        <h1 className="text-3xl font-heading font-semibold tracking-tight mb-6" data-testid="my-orders-title">My orders</h1>
        {loading ? <div className="text-sm text-gray-500">Loading…</div> :
         orders.length === 0 ? <div className="border border-gray-200 p-10 text-center text-sm text-gray-500" data-testid="orders-empty">No orders yet.</div> :
         <div className="space-y-3">
           {orders.map((o) => {
             const inv = o.invoice_id ? invoices[o.invoice_id] : null;
             return (
               <div key={o.id} className="border border-gray-200 p-4" data-testid={`my-order-${o.id}`}>
                 <div className="flex justify-between items-start flex-wrap gap-2">
                   <div>
                     <div className="text-xs text-gray-500">Placed {new Date(o.created_at).toLocaleString()}</div>
                     <div className="font-mono text-xs text-gray-400 mt-1">#{o.id.slice(-12)}</div>
                     {o.po_number && <div className="text-xs text-gray-500 mt-1" data-testid={`my-order-po-${o.id}`}>PO: <span className="font-medium text-gray-700">{o.po_number}</span></div>}
                   </div>
                   <span className={`status-pill ${pillCls(o.status)}`}>{o.status.replace("_"," ")}</span>
                 </div>
                 <div className="mt-3 space-y-1 text-sm">
                   {o.items.map((it, i) => (
                     <div key={`${it.product_id}-${it.variant_name}-${i}`} className="text-gray-700">{it.quantity} × {it.variant_name}{it.notes ? <span className="text-gray-400 italic"> · "{it.notes}"</span> : null}</div>
                   ))}
                 </div>
                 {inv && (
                   <div className="mt-3 pt-3 border-t border-gray-100 flex justify-between items-center text-sm">
                     <div className="text-gray-500">Invoice <span className="font-medium text-gray-900">{inv.zoho?.zoho_invoice_number || `#${inv.id.slice(-8)}`}</span></div>
                     <div className="flex items-center gap-3">
                       <span className="font-medium">{inr(inv.total)}</span>
                       <Link to={`/invoices/${inv.id}`} className="text-[#002fa7] text-xs hover:underline">View bill →</Link>
                     </div>
                   </div>
                 )}
               </div>
             );
           })}
         </div>}
      </div>
    </div>
  );
}
